import { NetworkNotGood } from './';

const NetworkBad = () => {
  const explanationText =
    'Our test indicated a bad connection. To prevent choppy sound or frozen video, try any of these tips:';

  return <NetworkNotGood explanationText={explanationText} />;
};

export default NetworkBad;
